/* Publish by EComposer at 2026-10-16 15:40:11*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-faycx3tkwth"]=  window.__ectimmers["ecom-faycx3tkwth"] || {};
const $el = this.$el;
                const products_item = $el.querySelectorAll(
                    ".ecom-product-bundle__item"
                );
                const products_title_item = $el.querySelectorAll(".item-for-loop");
                if (products_item.leng == 0) {
                    return;
                }
                const handleVariantSelect = () => {
                    if (products_title_item) {
                        products_title_item.forEach((item, index) => {
                            let select_id = item.querySelector(
                                "select[name=ecom-product-bundle-select]"
                            );
                            let item_images = item.querySelectorAll(
                                ".ecom-product-bundle__image"
                            );

                            if (!select_id) return;
                            select_id.addEventListener("change", (e) => {
                                let selected_index =
                                    select_id.options[select_id.selectedIndex];

                                if (!selected_index) return;

                                let price =
                                    selected_index.getAttribute("data-price");
                                let compare_at_price =
                                    selected_index.getAttribute(
                                        "data-compare-price"
                                    ) || 0;
                                let image =
                                    selected_index.getAttribute("data-image");
                                let product_id = selected_index.value;

                                item.querySelector(
                                    "input[name=product_id]"
                                ).value = product_id;
                                item.querySelector(
                                    ".product-bundle__checkbox-input"
                                ).setAttribute("data-product-price", price);
                                item.querySelector(
                                    ".product-bundle__checkbox-input"
                                ).setAttribute(
                                    "data-product-compare_price",
                                    compare_at_price
                                );
                                handleTotalPrice();
                                updatePrice(price, compare_at_price, item);

                                let item_for_loop_horizontal = $el.querySelectorAll('.item-for-loop-horizontal');
                                item_images.forEach(item => item.classList.add('ecom-loading-image'));
                                if(image) {
                                    item_images.forEach(item => item.querySelector('img').setAttribute('src', image));
                                    if(item_for_loop_horizontal && item_for_loop_horizontal[index])
                                        item_for_loop_horizontal[index].querySelector('img').setAttribute('src', image)
                                }
                                item_images.forEach(item => item.querySelector('img').onload = () => {
                                    item_images.forEach(item => item.classList.remove('ecom-loading-image'));
                                })
                            });
                        });
                    }

                    function updatePrice(price, compare_at_price, el) {
                        const $price_regular = el.querySelector(
                            ".ecom-product-bundle__price--regular"
                        );
                        const $price = el.querySelector(
                            ".ecom-product-bundle__price--sale"
                        );

                        if ($price) {
                            $price.innerHTML =
                                window.EComposer.formatMoney(price);
                        }

                        if ($price_regular) {
                            $price_regular.innerHTML =
                                window.EComposer.formatMoney(compare_at_price);
                            if (
                                parseFloat(compare_at_price) > parseFloat(price)
                            ) {
                                $price_regular.style.display = "inherit";
                            } else {
                                $price_regular.style.display = "none";
                            }
                        }
                    }
                };

                const handleMainProductVariantSelect = () => {
                    if (products_title_item.length == 0) return;
                    const product_form = document.querySelector(
                        "form.ecom-product-form--single"
                    );
                    const main_select =
                        product_form.querySelector("select[name=id]");
                    const main_product_bundle =
                        products_title_item[0].querySelector(
                            "select[name=ecom-product-bundle-select]"
                        );

                    if (!main_select || !main_product_bundle) return;
                    //Main select event
                    main_select.addEventListener("change", (e) => {
                        let value = e.target.value;
                        if (value && value != main_product_bundle.value) {
                            main_product_bundle.value = value;
                            main_product_bundle.dispatchEvent(
                                new Event("change")
                            );
                        }
                    });

                    //Bundle main product selet event
                    main_product_bundle.addEventListener("change", (e) => {
                        let value = e.target.value;
                        if (value) {
                            main_select.value = value;
                            main_select.dispatchEvent(new Event("swatch"));
                        }
                    });
                };

                const handleATC = () => {
                    const $btn_atc = $el.querySelector(
                        ".ecom-product-bundle__atc-btn"
                    );
                    let items = [];

                    $btn_atc.addEventListener("click", (e) => {
                        e.preventDefault();
                        const _this = e.target;
                        $btn_atc.classList.add("ecom-loading");

                        $el.querySelectorAll("input[type=checkbox]").forEach(
                            (checkbox, index) => {
                                if (checkbox.checked) {
                                    let product_id = products_title_item[
                                        index
                                    ].querySelector(
                                        "input[name=product_id]"
                                    ).value;
                                    if (!product_id) return;

                                    let item = {
                                        id: product_id,
                                        quantity: 1,
                                    };

                                    items.push(item);
                                }
                            }
                        );

                        if (items.length > 0) {
                            fetch("/cart/add.js?sections=cart-notification-product,cart-notification-button,cart-icon-bubble,cart-drawer", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({ items }),
                            })
                                .then((response) => response.json())
                                .then((response) => {
                                    if (
                                        response.status &&
                                        response.status == 422
                                    ) {
                                        window.EComposer.showToast(
                                            response.description,
                                            "error"
                                        );
                                        $btn_atc.classList.remove(
                                            "ecom-loading"
                                        );
                                        items = [];
                                        return;
                                    }
                                    if (window.EComposer.ajaxCartSuccess)
                                        window.EComposer.ajaxCartSuccess(
                                            response
                                        );
                                    $btn_atc.classList.remove("ecom-loading");
                                    items = [];
                                })
                                .catch((error) => {
                                    console.error("Error:", error);
                                });
                        }
                    });
                };

                const handleTotalPrice = () => {
                    let total_price = 0;
                    let total_compare_price = 0;
                    const checkboxs = $el.querySelectorAll(
                        "input[type=checkbox]"
                    );

                    if (!checkboxs) return;

                    if (this.settings.layout == "horizontal") {
                        var list = $el.querySelectorAll(
                            ".ecom-product-bundle__product-list .ecom-product-bundle__item "
                        );
                        list.forEach(function (item) {
                            item.style.opacity = 0.4;
                        });
                    }

                    checkboxs.forEach((checkbox, index) => {
                        checkbox.parentElement.style.opacity = 0.4;
                        if (checkbox.checked) {
                            let price =
                                checkbox.getAttribute("data-product-price");
                            let compare_price = checkbox.getAttribute(
                                "data-product-compare_price"
                            );
                            if (price) total_price += parseFloat(price);
                            if (compare_price && compare_price != '0')
                                total_compare_price +=
                                    parseFloat(compare_price);
                            else if (price)
                                total_compare_price += parseFloat(price);

                            checkbox.parentElement.style.opacity = 1;

                            if (this.settings.layout == "horizontal") {
                                if (list && list[index])
                                    list[index].style.opacity = 1;
                            }
                        }
                    });
                    $el.querySelector(
                        ".ecom-product-bundle__price--total"
                    ).innerHTML = window.EComposer.formatMoney(total_price);
                    if(this?.settings?.show_compare_price)
                        $el.querySelector(".ecom-product-bundle__price--compare").innerHTML = total_compare_price > total_price ? window.EComposer.formatMoney(total_compare_price) : "";
                };

                const handleCheckbox = function () {
                    const checkboxs = $el.querySelectorAll(
                        "input[type=checkbox]"
                    );
                    checkboxs.forEach((checkbox) => {
                        checkbox.addEventListener("change", handleTotalPrice);
                    });
                };

                const handleAnimation = function (_this) {
                    if (!$el) return;

                    const $btn_wrapper = $el.querySelector(
                        ".ecom-product-bundle__atc-btn"
                    );
                    if (!$btn_wrapper) return;

                    let intervalTime =
                            parseInt(_this?.settings.animation_loop_time) *
                                1000 || 6000,
                        animTime = 1000;window.__ectimmers["ecom-faycx3tkwth"]["c2lys4t3a"] = setInterval(function () {
                        $btn_wrapper.classList.add("animated");
                        setTimeout(function () {
                            $btn_wrapper.classList.remove("animated");
                        }, animTime);
                    }, intervalTime);
                };

                if (this.settings.animation) {
                    handleAnimation(this);
                }

                handleVariantSelect();
                handleMainProductVariantSelect();
                handleTotalPrice();
                handleCheckbox();
                if (!window.ECOM_LIVE) handleATC();

                    });
                    
                        document.querySelectorAll('.ecom-faycx3tkwth').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-faycx3tkwth', settings: {"layout":"vertical","show_compare_price":true,"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}